// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {ChatActionCell} from './ChatActionCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {UserJoinedDate} from './UserJoinedCell'
import {User} from '../../core/_models'
import { UserStatuCell } from './UserStatusCell'
import { ViewChatCell } from './ViewChatCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Chat ID' className='min-w-125px' />,
    id: '_id',
    Cell: ({...props}) => <UserInfoCell chat={props.data[props.row.index]} />,
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
  //   ),
  //   accessor: 'email',
  // },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='Role' className='min-w-125px' />,
  //   accessor: 'role',
  // },
  { id : 'messages',
    Header: (props) => <UserCustomHeader tableProps={props} title='Total Messages' className='min-w-125px' />,
    Cell: ({...props}) => <UserStatuCell chat={props.data[props.row.index]} />,
  },

  //sdf
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Last Updated' className='min-w-125px' />
    ),
    id: 'updatedAt',
    Cell: ({...props}) => <UserJoinedDate chat={props.data[props.row.index]} />,
  },

  // { id : 'view',
  //   Header: (props) => <UserCustomHeader tableProps={props} title='View' className='min-w-125px' />,
  //   Cell: ({...props}) => <ViewChatCell chat={props.data[props.row.index]} />,
  // },
  
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <ChatActionCell id={props.data[props.row.index]._id} 
    chat={props.data[props.row.index]}
    />,
  },


  
]

export {usersColumns}
